<template>
  <div>
    <h2 class="title-24-800">
      {{ title }}
    </h2>
    <client-only>
      <ul
        class="improvement-areas"
      >
        <li
          v-for="(item, idx) of options"
          :key="item.id"
          class="improvement-areas__item"
        >
          <transition :name="transition">
            <div
              v-if="idx <= showIdx"
              class="improvement-areas__item-wrapper"
            >
              <nuxt-icon
                :name="item.icon"
                filled
              />
              <p class="improvement-areas__item-text paragraph-16-600">
                {{ $t(item.name) }}
              </p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M7.5 3L15 12.5976H0L7.5 3Z"
                  fill="url(#paint0_linear_8499_43805)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_8499_43805"
                    x1="7.5"
                    y1="3"
                    x2="7.5"
                    y2="12.5976"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop
                      offset="0.395833"
                      stop-color="#53CC58"
                    />
                    <stop
                      offset="1"
                      stop-color="#429746"
                      stop-opacity="0"
                    />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </transition>
        </li>
      </ul>
    </client-only>
  </div>
</template>

<script lang="ts" setup>
import type { ImprovementAreasModel } from '@quiz/models/ImprovementAreasModel';

const props = defineProps({
  title: {
    type: String,
  },
  showAll: {
    type: Boolean,
    default: false,
  },
  transition: {
    type: String,
    default: '',
  },
  showElementIdx: {
    type: Number,
    default: 99,
  },
  options: {
    type: Array as PropType<ImprovementAreasModel[]>,
  },
  dark: {
    type: Boolean,
    default: false,
  },
});

const showIdx = toRef(props, 'showElementIdx');
const itemColor = computed(() => props.dark ? '#fff' : 'rgba(17, 17, 19, 0.80)');
</script>

<style lang="scss" scoped>
.improvement-areas {
  display: flex;
  flex-direction: column;
  margin-top: 32px;

  &__item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__item-text {
    color: v-bind(itemColor);
    margin-right: 8px;
    margin-left: 24px;
    white-space: nowrap;
  }

  &__item-wrapper {
    display: flex;
    align-items: center;
  }

  .nuxt-icon {
    font-size: 44px;
    line-height: 0;
    height: 44px;
  }
}

.left-slide-list-enter-active,
.left-slide-list-leave-active {
  transition: all .5s ease;
}
.left-slide-list-enter-from,
.left-slide-list-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}
</style>
